import React from "react";
import ResponsiveImage from "../../atoms/image/ResponsiveImage";

type DescriptionProps = {
  data: string[];
};

const Description = ({ data }: DescriptionProps) => {
  return data.map((item, count) => (
    <p
      className={`${count > 0 ? "lg:mt-1.5 md:mt-1.5" : ""}`}
      dangerouslySetInnerHTML={{ __html: item }}
      key={count}
    />
  ));
};

type ImageData = {
  image: {
    align: string;
    alt: string;
    path: string;
  };
  heading: string;
  desc: string[];
};

type ImageProps = {
  data: ImageData;
  classes?: string;
};

const ImageLeft = ({ data, classes }: ImageProps) => (
  <div className={`grid--default has-align-middle ${classes}`}>
    <ResponsiveImage
      dpi="@2x"
      wrapClass="lg:maxw-lg"
      mobile="crop"
      imgClass="imgholder-primary"
      alt={data.image.alt}
      src={data.image.path}
    />
    <article className="text-left lg:maxw-md">
      <h2
        className="text-lg lg:mb-3 md:mb-2 md:mt-5"
        dangerouslySetInnerHTML={{ __html: data.heading }}
      />
      <Description data={data.desc} />
    </article>
  </div>
);

const ImageRight = ({ data, classes }: ImageProps) => (
  <div
    className={`grid--default has-align-middle lg:mt-15 md:mt-10 md:fx md:fx--w ${classes}`}
  >
    <article className="text-left lg:maxw-md fx--o-2">
      <h2
        className="text-lg lg:mb-3 md:mb-2 md:mt-5"
        dangerouslySetInnerHTML={{ __html: data.heading }}
      />
      <Description data={data.desc} />
    </article>
    <ResponsiveImage
      dpi="@2x"
      mobile="crop"
      wrapClass="lg:maxw-lg"
      imgClass="imgholder-primary"
      alt={data.image.alt}
      src={data.image.path}
    />
  </div>
);

type FeaturedImageProps = {
  data: ImageData[];
  classes?: string;
};

export default function FeaturedImage({ data, classes }: FeaturedImageProps) {
  return data.map((item, count) =>
    item.image.align === "left" ? (
      <ImageLeft data={item} key={count} classes={classes} />
    ) : (
      <ImageRight data={item} key={count} classes={classes} />
    )
  );
}
